export function rangePx(from: number, to?: number, inclusive = false) {
  let mediaString = `@media screen and (min-width: ${from}px)`;

  if (to !== undefined) {
    mediaString += ` and (max-width: ${inclusive ? to : to - 1}px)`;
  }
  return mediaString;
}
